// Enter-to-send policy for the message composers (buyer entry/workspace chat,
// concierge dashboard answers, seller replies, admin conversation panels).
//
// Desktop (fine pointer): Enter sends; Shift+Enter inserts a newline.
// Touch (coarse pointer): on-screen keyboards have no Shift key, so a
// multi-line message would be impossible — Enter ALWAYS inserts a newline and
// only the send button sends.
// Mid-IME composition, Enter commits the composition, never the message.

/** The slice of a React `KeyboardEvent` the send-on-Enter decision reads.
 *  Structural, so unit tests can pass a plain object. */
export interface EnterKeyEvent {
  key: string;
  shiftKey: boolean;
  nativeEvent: { isComposing: boolean };
}

/** Pure decision: should this composer keydown submit the message? */
export function shouldSendOnEnter(event: EnterKeyEvent, coarsePointer: boolean): boolean {
  return (
    event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing && !coarsePointer
  );
}

// Detected once and cached — keydown handlers call this per keystroke, and a
// device's primary pointer doesn't change mid-session in any case we care about.
let coarsePointerCache: boolean | undefined;

/** True on touch-first devices (phones/tablets): the PRIMARY pointer is coarse.
 *  Same signal the stylesheets key touch affordances off — never width. */
export function isCoarsePointer(): boolean {
  coarsePointerCache ??=
    typeof window !== "undefined" && (window.matchMedia?.("(pointer: coarse)").matches ?? false);
  return coarsePointerCache;
}
